export default function (instance) {
    return {
        Get(payload) {
            return instance.get(`/Account/Get?guid=${payload.guid}`);
        },
    }
}
